import { Box, Button, Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Popover from "@material-ui/core/Popover";
// import ViewColumn from "@material-ui/icons/ViewColumn";
import React, { FC, useState } from "react";

export interface ColumnChoice {
  key: string;
  label: string;
  visible?: boolean;
  disabled?: boolean;
}

export const getDefaultVisibleColumns = (columns: ColumnChoice[]): string[] =>
  columns
    .filter((c) => c.visible === true || c.disabled === true)
    .map((c) => c.key);

interface ColumnToggleButtonProps {
  columns: ColumnChoice[];
  visibleColumns: string[];
  onToggle: (key: string) => void;
  onReset?: () => void;
  label?: string;
}

const ColumnToggleButton: FC<ColumnToggleButtonProps> = ({
  columns,
  visibleColumns,
  onToggle,
  onReset,
  label = "Show Columns",
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={handleClick}
        title="Columns"
        disableElevation
      >
        {/* <ViewColumn style={{ marginRight: 6, fontSize: 20 }} /> */}
        {label}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: {
            minWidth: 220,
          },
        }}
      >
        <div
          style={{
            padding: "0.5rem 1rem",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2">Columns</Typography>
            {onReset && (
              <Button
                size="small"
                variant="text"
                disableElevation
                onClick={onReset}
                style={{
                  color: "#E91E63",
                }}
              >
                Reset
              </Button>
            )}
          </Box>
          <div
            style={{
              padding: "0.25rem 0.5rem 0.75rem 0.5rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {columns.map((col) => (
              <FormControlLabel
                key={col.key}
                control={
                  <Checkbox
                    checked={visibleColumns.includes(col.key)}
                    onChange={() => onToggle(col.key)}
                    color="primary"
                    size="small"
                    disabled={col.disabled}
                    style={{
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }}
                  />
                }
                label={col.label}
              />
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default ColumnToggleButton;
